// SEO configuration per route. Titles kept concise (~55 chars),
// descriptions under 160 chars, unique per page.
//
// Host detection is runtime-driven: production origin is always
// https://gpfzllc.com regardless of whether the visitor landed on the
// apex or www. Preview hosts (`.preview.emergentagent.com`,
// `.emergent.host`) fall back to `window.location.origin` for
// canonicals and get `<meta name="robots" content="noindex, nofollow">`
// injected client-side by Seo.jsx.

export const SITE = {
  name: "Gold Petroleum FZ LLC",
  short: "Gold Petroleum",
  strapline: "Petroleum, gas, derivatives and non-manufactured precious metals.",
};

const PRODUCTION_ORIGIN = "https://gpfzllc.com";

function detectProductionHost() {
  if (typeof window === "undefined") return false;
  const host = (window.location.hostname || "").toLowerCase();
  // Match gpfzllc.com and any subdomain of it (e.g. www.gpfzllc.com), but
  // NOT preview hosts that happen to contain the string.
  if (!/(^|\.)gpfzllc\.com$/i.test(host)) return false;
  if (host.includes("preview")) return false;
  if (host.includes("emergent.host")) return false;
  return true;
}

export const IS_PRODUCTION = detectProductionHost();

export const PUBLIC_ORIGIN = IS_PRODUCTION
  ? PRODUCTION_ORIGIN
  : (typeof window !== "undefined" ? window.location.origin.replace(/\/$/, "") : "");

export const ALLOW_INDEXING = IS_PRODUCTION;

// Legacy export retained for callers that imported `getBaseUrl()`.
export function getBaseUrl() {
  return PUBLIC_ORIGIN;
}

export const ROUTES = {
  "/": {
    title: "Gold Petroleum FZ LLC — Energy, metals, enduring partnerships",
    description:
      "UAE-registered trading company connecting petroleum and precious metals markets through transparency, consistency and shared value.",
    ogImage: "/commercial-poster.jpg",
  },
  "/company": {
    title: "Our Company — Gold Petroleum FZ LLC",
    description:
      "A UAE-registered trading company focused on petroleum products and non-manufactured precious metals. Learn our values, vision and mission.",
    ogImage: "/img/refinery-dusk.jpg",
  },
  "/divisions": {
    title: "Our Divisions — Gold Petroleum FZ LLC",
    description:
      "Two divisions, one standard: Petroleum & Energy trading and non-manufactured Precious Metals across the Middle East, Africa and Asia.",
    ogImage: "/img/port-aerial.jpg",
  },
  "/divisions/petroleum-energy": {
    title: "Petroleum & Energy — Gold Petroleum FZ LLC",
    description:
      "Trading and distribution of crude, refined products, gas and related commodities including diesel, gasoline, jet fuel, bitumen and urea.",
    ogImage: "/img/refinery-pipes.jpg",
  },
  "/divisions/precious-metals": {
    title: "Precious Metals — Gold Petroleum FZ LLC",
    description:
      "Raw, non-manufactured precious metals trading: gold doré, silver and platinum. We do not manufacture or sell jewellery.",
    ogImage: "/img/gold-dore.jpg",
  },
  "/strategic-relationships": {
    title: "Strategic Relationships — Gold Petroleum FZ LLC",
    description:
      "Long-standing partner relationships in shipping, terminal storage and refining across the Middle East, Africa and Asia.",
    ogImage: "/img/oil-tanker.jpg",
  },
  "/leadership": {
    title: "Leadership — Gold Petroleum FZ LLC",
    description:
      "A message from Ken Salvadore, President & CEO of Gold Petroleum FZ LLC.",
    ogImage: "/img/refinery-dusk.jpg",
  },
  "/careers": {
    title: "Careers — Gold Petroleum FZ LLC",
    description:
      "Register your interest with Gold Petroleum FZ LLC — a growing international trading company that values initiative and judgement.",
    ogImage: "/img/storage-tanks.jpg",
  },
  "/contact": {
    title: "Contact Gold Petroleum FZ LLC",
    description:
      "Reach the Gold Petroleum team by email or phone, or send a written enquiry. We respond directly.",
    ogImage: "/img/port-aerial.jpg",
  },
  "/privacy": {
    title: "Privacy Notice — Gold Petroleum FZ LLC",
    description:
      "How Gold Petroleum FZ LLC collects, uses and protects information you share via our enquiry form.",
    ogImage: "/img/refinery-dusk.jpg",
  },
  "/404": {
    title: "Page not found — Gold Petroleum FZ LLC",
    description: "The page you requested could not be found.",
    ogImage: "/commercial-poster.jpg",
  },
};

export function orgJsonLd(baseUrl) {
  const base = baseUrl || PUBLIC_ORIGIN || "";
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.name,
    url: base,
    logo: base ? `${base}/brand/logo-full.svg` : undefined,
    description:
      "UAE-registered trading company engaged in the trading and distribution of petroleum and petroleum products, with a dedicated focus on non-manufactured precious metals.",
    areaServed: ["Middle East", "Africa", "Asia"],
    sameAs: [],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        email: "sales@gpfzllc.com",
        availableLanguage: ["English"],
      },
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        email: "admin@gpfzllc.com",
        availableLanguage: ["English"],
      },
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        telephone: "+972-56-585-0606",
        availableLanguage: ["English"],
      },
      {
        "@type": "ContactPoint",
        contactType: "sales",
        name: "Fabio",
        telephone: "+1-416-277-5262",
        availableLanguage: ["English"],
      },
    ],
  };
}
